import {
	isToolResultContent,
	isToolUseContent,
	type ChatMessageDto,
	type ToolUseContentBlock,
} from "@/lib/chat";

/**
 * 新しく届いた tool_result 行から、成功したツール呼び出しの tool_use を返す。対応する tool_use は
 * 1 応答分がまとめて直前の assistant 行に入っている。サーバが実行して成功を返したものだけを起点に
 * 画面を動かすため、tool_use ではなく tool_result を見る。
 */
export function succeededAgentToolUses(
	dto: ChatMessageDto,
	messages: readonly ChatMessageDto[],
): ToolUseContentBlock[] {
	if (dto.role !== "user") return [];
	const succeededIds = new Set(
		dto.content
			.filter(isToolResultContent)
			.filter((block) => block.is_error !== true)
			.map((block) => block.tool_use_id),
	);
	if (succeededIds.size === 0) return [];

	return (messages.findLast((m) => m.role === "assistant")?.content ?? [])
		.filter(isToolUseContent)
		.filter((block) => succeededIds.has(block.id));
}

/**
 * 成功した open_file 呼び出しのパスを返す。プレビュータブは開き直すたびに置き換わるので、
 * 同じ応答で複数開いた場合は最後の 1 件だけを返す。
 */
export function agentOpenFilePath(
	dto: ChatMessageDto,
	messages: readonly ChatMessageDto[],
): string | null {
	const path = succeededAgentToolUses(dto, messages).findLast((block) => block.name === "open_file")
		?.input.path;
	return typeof path === "string" ? path : null;
}
